module.exports = __webpack_public_path__ + "static/img/img-xzgt.56ba9b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/img-xzgt.png
// module id = wJOf
// module chunks = 0